/* Centro de Ayuda — L'Autrichienne by Sacher
   Vanilla JS, sin dependencias. Hace tres cosas:
     1. buscador con sugerencias (lee el feed JSON del blog)
     2. desvío al catálogo cuando preguntan por un tema ("star wars")
     3. el chat: contesta con lo publicado y, si no lo tiene, manda a WhatsApp
   Si el ERP no contesta, o si el feed falla, la página sigue sirviendo:
   el contenido y los enlaces están en el HTML, no aquí. */
(function () {
  "use strict";

  /* UNA SOLA VEZ, pase lo que pase.

     En una página de artículo hay DOS secciones que piden este archivo: la del
     artículo y la del chat. El navegador lo ejecuta las dos veces, y sin este
     candado cada oyente quedaba puesto por duplicado: un clic en "No del todo"
     mandaba DOS votos, y cada búsqueda contaba doble.

     No se notó en su día porque la ruta que los recibe no existía todavía y
     todo caía en saco roto. En cuanto empezó a guardarse, se vio: dos filas
     idénticas al mismo segundo por un solo clic.

     El candado va aquí y no en el Liquid a propósito: así da igual cuántas
     secciones acaben incluyéndolo mañana. */
  if (window.__kbYaCargado) { return; }
  window.__kbYaCargado = true;

  var API = window.KB_API || "https://sistema.sacher.com.mx/api/v1/public/kb";

  /* EL IDIOMA DE LA PÁGINA, y con él QUÉ BASE se lee.
     El centro de ayuda en inglés vive en el blog `help`. Sin esto, el buscador
     del widget en una página inglesa buscaba en los artículos en español y le
     ofrecía al lector títulos que no podía leer. */
  var ES_INGLES = (function () {
    var p = document.getElementById("kb-panel");
    if (p && p.getAttribute("data-kb-idioma") === "en") return true;
    return /^\/(en\/)?blogs\/help(\/|$)/.test(location.pathname);
  })();
  var BLOG = ES_INGLES ? "help" : "ayuda";

  /* EL ÍNDICE SE PIDE EN EL IDIOMA DE LA VISITA.
     Shopify sirve la misma página bajo dos rutas: /blogs/help y /en/blogs/help.
     La primera va en el locale español, y las URL que Shopify escribe dentro
     salen SIN el prefijo. Pedir el índice a pelo dejaba unos enlaces que, al
     pulsarlos, devolvían al inglés al marco español: mismo texto, cabecera y
     pie en español. Se pide desde la raíz del locale de esta visita, que es la
     que Shopify pone en Shopify.routes.root. */
  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  RAIZ = String(RAIZ).replace(/\/$/, "");
  /* El índice INGLÉS se pide siempre desde /en/, aunque la visita venga por la
     ruta sin prefijo: así las URL que Shopify escribe dentro llegan ya con él y
     el primer clic deja al cliente donde el marco también habla inglés. */
  var FEED = (ES_INGLES ? "/en" : RAIZ) + "/blogs/" + BLOG + "?view=kb-json";
  var CACHE = "kb-feed-v3-" + BLOG;
  var MIN = 30;

  /* Lo que el chat dice por su cuenta. Lo demás (títulos, respuestas) sale del
     feed, que ya viene en el idioma que toca. */
  var TABLAS = {};
  TABLAS.en = {
    saludo: "Hello. Tell me what you need and I will answer with what the house says: how much cake for your number of guests, flavours, prices, delivery or dates.",
    siTenemos: "Yes, we have ", cakesOf: " cakes.",
    verColeccion: "See the ", verColeccionFin: " collection",
    aMedida: "I want one made to measure",
    enCatalogo: "The catalogue does have ", enCatalogoFin: " cakes. Have a look at these:",
    verTodos: "See all the ",
    noTengo1: "I have nothing published about ", noTengo2: ", and I cannot find it in the catalogue either. That does not mean it cannot be done: almost everything we are asked for is made to measure. Let me put you through to someone at the shop.",
    preguntarWa: "Ask on WhatsApp", verCatalogo: "See the catalogue",
    comoPedimos: "How we make bespoke cakes",
    leerCompleto: "Read the full article",
    tambien: "This might also help:",
    graciasSi: "Thank you. That tells us what is well explained.",
    graciasNo: "Thank you. This article goes back for review.",
    sinCoincidencias: "No matches here. Press Search and we will look in the catalogue too.",
    deDonde: "Where this comes from",
    hablar: "Talk to a person",
    verLos: "See ",
    tenemosDe: "We have a whole collection of ", tenemosDeFin: ". These are some of them:",
    noEsExacto: "If none of these is quite it, we make bespoke cakes: tell us what you have in mind."
  };
  TABLAS.es = {
    saludo: "Hola. Cuéntame qué necesitas y te contesto con lo que dice la casa: cuánto pastel para tu número de personas, sabores, precios, entregas o fechas.",
    siTenemos: "Sí, tenemos pasteles de ", cakesOf: ".",
    verColeccion: "Ver la colección de ", verColeccionFin: "",
    aMedida: "Quiero uno a la medida",
    enCatalogo: "En el catálogo sí hay pasteles de ", enCatalogoFin: ". Mira estos:",
    verTodos: "Ver todos los de ",
    noTengo1: "No tengo publicado nada sobre ", noTengo2: ", y en el catálogo tampoco lo encuentro. Pero eso no quiere decir que no se pueda: casi todo lo que nos piden se hace a la medida. Te paso con una persona del mostrador.",
    preguntarWa: "Preguntar por WhatsApp", verCatalogo: "Ver el catálogo",
    comoPedimos: "Cómo pedimos a la medida",
    leerCompleto: "Leer el artículo completo",
    tambien: "También puede servirte:",
    graciasSi: "Gracias. Nos dice qué está bien explicado.",
    graciasNo: "Gracias. Este artículo entra a revisión.",
    sinCoincidencias: "Sin coincidencias aquí. Pulsa Buscar y miramos también en el catálogo.",
    deDonde: "De dónde sale esto",
    hablar: "Hablar con una persona",
    verLos: "Ver ",
    tenemosDe: "Tenemos una colección entera de ", tenemosDeFin: ". Estos son algunos:",
    noEsExacto: "Si ninguno es justo lo que buscas, los hacemos a la medida: cuéntanos qué tienes en mente."
  };
  var T = ES_INGLES ? TABLAS.en : TABLAS.es;

  /* EN QUÉ IDIOMA ESCRIBIÓ EL CLIENTE.
     El agente ya contesta en el idioma de quien pregunta, no en el de la
     página: alguien puede escribir en inglés estando en la versión española.
     Cuando eso pasa, lo que va ALREDEDOR de la respuesta —el "de dónde sale
     esto", el botón de hablar con una persona— tiene que ir en el mismo idioma
     que la respuesta, o queda un mensaje en inglés con botones en español.
     Misma cuenta que hace el ERP: se pesan las palabras de función. */
  var PALABRAS_EN = [
    " the ", " you ", " do ", " does ", " what ", " how ", " is ", " are ", " can ", " could ",
    " your ", " my ", " i ", " to ", " for ", " of ", " in ", " it ", " and ", " with ",
    " have ", " need ", " want ", " cake ", " cakes ", " order ", " delivery ", " much ", " many ", " there "
  ];
  var PALABRAS_ES = [
    " el ", " la ", " los ", " las ", " que ", " como ", " para ", " por ",
    " un ", " una ", " unos ", " unas ", " mi ", " es ", " son ", " de ", " del ", " al ",
    " con ", " sus ", " su ", " en ", " se ", " hasta ", " donde ", " cuando ",
    " cuanto ", " cuanta ", " tienen ", " tiene ", " hacen ", " quiero ", " necesito ",
    " pastel ", " pasteles ", " entrega ", " entregas ", " precio "
  ];

  function idiomaDe(q) {
    var bruto = String(q || "");
    // Un signo que solo existe en español zanja la cuestión.
    if (/[¿¡ñÑ]/.test(bruto)) return "es";
    // norm() ya quita las tildes, así que se miran ANTES sobre el texto crudo.
    var conTildes = /[áéíóúÁÉÍÓÚ]/.test(bruto);
    var t = " " + norm(bruto).replace(/[.,;:!?()"']/g, " ").replace(/\s+/g, " ") + " ";
    var en = 0, es = 0;
    PALABRAS_EN.forEach(function (w) { if (t.indexOf(w) >= 0) en += 1; });
    PALABRAS_ES.forEach(function (w) { if (t.indexOf(w) >= 0) es += 1; });
    if (conTildes) es += 1;
    if (en === es) return ES_INGLES ? "en" : "es";
    return en > es ? "en" : "es";
  }

  function tablaDe(idioma) { return TABLAS[idioma] || T; }

  // Todo lo que venga del catálogo se escapa antes de pintarlo: son textos de
  // fuera y van dentro de atributos HTML.
  function esc(x) {
    return String(x == null ? "" : x)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function norm(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); }
  function sinHtml(s) { var d = document.createElement("div"); d.innerHTML = String(s || ""); return (d.textContent || "").trim(); }

  /* ---------- el índice ---------- */
  var feedP = null;
  function getFeed() {
    if (feedP) return feedP;
    try {
      var raw = sessionStorage.getItem(CACHE);
      if (raw) {
        var b = JSON.parse(raw);
        if (b && b.t && Date.now() - b.t < MIN * 60000 && b.d) { feedP = Promise.resolve(b.d); return feedP; }
      }
    } catch (e) {}
    feedP = fetch(FEED, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { articles: [] }; })
      .then(function (j) {
        var d = j && j.articles ? j : { articles: [] };
        try { sessionStorage.setItem(CACHE, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      })
      .catch(function () { return { articles: [] }; });
    return feedP;
  }

  /* ---------- búsqueda ---------- */
  var STOP = { de:1,del:1,la:1,las:1,el:1,los:1,un:1,una:1,unos:1,unas:1,con:1,sin:1,por:1,para:1,que:1,como:1,cual:1,
    cuanto:1,cuanta:1,cuantos:1,cuantas:1,donde:1,cuando:1,mi:1,mis:1,tu:1,sus:1,hay:1,tiene:1,tienen:1,puedo:1,pueden:1,
    quiero:1,necesito:1,son:1,esta:1,este:1,esto:1,eso:1,ese:1,esa:1,al:1,se:1,su:1,lo:1,pastel:1,pasteles:1,ustedes:1,me:1 };
  /* Saludos y tecleos sueltos. No son preguntas y no deben acabar en
     "no tengo publicado nada sobre «Hola»": eso es lo primero que leyó mucha
     gente, y espanta. Se detectan aparte para poder saludar de vuelta. */
  var SALUDOS = /^(hola|holi|holq|hol|buen(os|as)?( ?(dias|tardes|noches|tarde|dia))?|que tal|qtal|saludos|hey|hi|hello|buenas)$/;
  function esSaludo(q) {
    var n = norm(q).replace(/[^a-z0-9\s]/g, "").replace(/\s+/g, " ").trim();
    if (!n) return false;
    if (SALUDOS.test(n)) return true;
    // "hola buenas noches", "hola buena tatde": empieza saludando y no pregunta nada.
    return /^(hola|buen(os|as))\b/.test(n) && n.split(" ").length <= 4;
  }

  /* Palabras que la gente escribe de otra manera. Salen de lo que de verdad se
     buscó y no encontró nada: "tienes pastel de 3 leches" no casaba con el
     artículo "tres leches", y "tienen wats?" no casaba con nada. */
  var IGUALES = {
    "1":"uno","2":"dos","3":"tres","4":"cuatro","5":"cinco","6":"seis",
    "7":"siete","8":"ocho","9":"nueve","10":"diez","12":"doce",
    uno:"1", dos:"2", tres:"3", cuatro:"4", cinco:"5", seis:"6",
    siete:"7", ocho:"8", nueve:"9", diez:"10", doce:"12",
    wats:"whatsapp", wasap:"whatsapp", whats:"whatsapp", wpp:"whatsapp", wa:"whatsapp",
    cel:"celular", tel:"telefono", face:"facebook", insta:"instagram",
    arcoiris:"rainbow", rainbow:"arcoiris", kilo:"kilos", rebanada:"rebanadas"
  };

  // Las palabras TAL COMO las escribió la persona, sin añadir sinónimos.
  function terminosCrudos(q) {
    // "porciones10" es una sola palabra para el navegador y dos para una
    // persona. Se separan letras de números antes de partir por espacios.
    // Los signos van pegados a la palabra y arruinan la coincidencia: "galletas?"
    // no casa con "galletas", y en español casi toda pregunta termina en "?".
    // Esto llevaba roto desde el principio y explica buena parte de las
    // búsquedas que no encontraban nada.
    var base = norm(q)
      .replace(/[¿?¡!.,;:()"'«»]/g, " ")
      .replace(/([a-z])(\d)/g, "$1 $2").replace(/(\d)([a-z])/g, "$1 $2");
    // Los números de una o dos cifras se quedan: "3" es lo que hay que convertir
    // en "tres" para que "3 leches" encuentre el artículo de tres leches.
    return base.trim().split(/\s+/).filter(function (t) {
      return !STOP[t] && (t.length > 2 || /^\d+$/.test(t));
    });
  }

  // Y las mismas MÁS sus equivalentes. Eso lo quiere el buscador de artículos,
  // donde cuantas más formas de decir lo mismo, mejor. El buscador de la
  // TIENDA no: allí cada variante va por separado, o se acaba preguntando por
  // "rainbow arcoiris", que no es nada.
  function terminos(q) {
    var vistos = {}, salida = [];
    terminosCrudos(q).forEach(function (t) {
      if (!vistos[t]) { vistos[t] = 1; salida.push(t); }
      var otro = IGUALES[t];
      if (otro && !vistos[otro]) { vistos[otro] = 1; salida.push(otro); }
    });
    return salida;
  }

  function buscar(arts, q) {
    var ts = terminos(q);
    if (!ts.length) return [];
    /* EL TOPE DE TRES ES EL ARREGLO QUE MÁS PESA.
       Antes se pedía que casara la MITAD de las palabras. Con una frase larga
       eso es imposible: alguien escribió dieciséis palabras preguntando por la
       anticipación, hacían falta ocho coincidencias, y el artículo de
       anticipación estaba publicado desde el primer día. Cuanto mejor
       explicaba el cliente lo que quería, menos encontraba. En una frase larga
       bastan DOS palabras que casen, y siempre con la condición de que al menos
       una caiga en el título, en los sinónimos o en la respuesta corta: eso es
       lo que evita que cualquier cosa empate con cualquier artículo. */
    var min = ts.length > 4 ? 2 : Math.ceil(ts.length / 2);
    return arts.map(function (a) {
      var t = norm(a.title), r = norm(a.answer), k = norm(a.keywords || ""),
          b = norm(a.body_text || "") + " " + norm(a.category_name || "");
      var s = 0, m = 0, f = 0;
      for (var i = 0; i < ts.length; i++) {
        var x = ts[i], h = 0;
        if (t.indexOf(x) >= 0) { s += 6; h = 1; f = 1; }
        if (k.indexOf(x) >= 0) { s += 5; h = 1; f = 1; }
        if (r.indexOf(x) >= 0) { s += 3; h = 1; f = 1; }
        if (b.indexOf(x) >= 0) { s += 1; h = 1; }
        m += h;
      }
      return { a: a, s: s, m: m, f: f };
    }).filter(function (x) {
      // Una palabra que cae en el TÍTULO o en los sinónimos ya es suficiente,
      // aunque el resto de la frase no case: quien escribe "hola me interesa un
      // pastel personalizado" está preguntando por personalizar, y pedirle dos
      // coincidencias a esa frase la dejaba sin respuesta.
      // El resto del texto del artículo no cuenta para esto: si contara,
      // cualquier palabra común empataría con cualquier artículo.
      return x.f === 1 && (x.m >= min || x.s >= 5);
    })
      /* Primero CUÁNTAS palabras casan: un artículo que toca dos de las
         palabras de la pregunta suele ser mejor respuesta que uno que toca
         una sola, aunque la tenga en el título.

         PERO NO SIEMPRE, y eso costaba respuestas. "pastel de cigüeña para
         niño, relleno" se iba al artículo del ALCOHOL —que casaba "pastel" y
         "niño", s=7— en vez de al del relleno, que tenía la palabra en el
         título y en los sinónimos con s=15. Ganaba por una palabra común
         teniendo menos de la mitad de puntuación.

         Así que una palabra menos se perdona cuando el otro casi DOBLA en
         puntos. Eso solo ocurre si la palabra cayó en el título (6) o en los
         sinónimos (5), nunca por texto suelto del cuerpo (1). Medido sobre 15
         preguntas reales sacadas de los registros: 12 aciertos con la regla
         vieja, 13 con esta, y ninguna de las que ya acertaba se rompe. */
      .sort(function (x, y) {
        if (x.m !== y.m) {
          var mas = x.m > y.m ? x : y, menos = x.m > y.m ? y : x;
          if (menos.s >= mas.s * 1.8) { return menos === x ? -1 : 1; }
          return y.m - x.m;
        }
        return y.s - x.s;
      })
      .map(function (x) { return x.a; });
  }

  /* ---------- preguntarle al catálogo por un tema que no está en la lista ----------

     La lista curada de temas son 46 y apuntan a colecciones de verdad, que son
     mejor aterrizaje que un listado de búsqueda. Pero fuera de esos 46 el chat
     se quedaba mudo: alguien escribió "quiero un pastel de rainbow" y se le
     contestó que no había nada publicado, cuando en la tienda hay un "Pastel
     Corazón Arcoíris" y media docena más.

     Ninguna lista escrita a mano va a cubrir todo lo que a una persona se le
     ocurre pedir en un pastel. Así que cuando el tema no está en la lista, se
     le pregunta al buscador de la propia tienda, que sabe lo que hay hoy. Si
     contesta con productos, el cliente va a verlos; si no contesta nada, se le
     dice la verdad y se le pasa con una persona.

     La consulta se prueba en varias formas porque la gente mezcla idiomas:
     "arcoiris" y "rainbow" encuentran cosas distintas, y las dos son suyas. */
  function buscaEnLaTienda(q) {
    var ts = terminosCrudos(q);
    if (!ts.length) return Promise.resolve(null);

    // De lo más específico a lo más general, y CADA VARIANTE POR SEPARADO.
    var intentos = [];
    function apunta(t) { if (t && intentos.indexOf(t) < 0) intentos.push(t); }
    if (ts.length > 1) apunta(ts.join(" "));
    ts.slice().sort(function (a, b) { return b.length - a.length; }).forEach(function (t) {
      apunta(t);
      apunta(IGUALES[t]);
    });
    intentos = intentos.slice(0, 4);

    function prueba(i) {
      if (i >= intentos.length) return Promise.resolve(null);
      var termino = intentos[i];
      var url = RAIZ + "/search/suggest.json?q=" + encodeURIComponent(termino) +
                "&resources[type]=product&resources[limit]=4";
      return fetch(url, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var prods = j && j.resources && j.resources.results && j.resources.results.products;
          if (prods && prods.length) return { termino: termino, productos: prods };
          return prueba(i + 1);
        })
        .catch(function () { return prueba(i + 1); });
    }
    return prueba(0);
  }

  /* ---------- temas del catálogo ---------- */
  function temaDe(q) {
    if (!window.KB_TEMAS) return null;
    var n = norm(q);
    for (var i = 0; i < KB_TEMAS.length; i++) {
      var cl = KB_TEMAS[i].k.split(",");
      for (var j = 0; j < cl.length; j++) {
        var c = norm(cl[j]).trim();
        if (c && n.indexOf(c) >= 0) return KB_TEMAS[i];
      }
    }
    return null;
  }

  /* ---------- registro en el ERP (silencioso) ---------- */
  function reporta(ruta, datos) {
    try {
      fetch(API + ruta, { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos), keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- buscador de la portada ---------- */
  function initBuscador(root) {
    var caja = root.querySelector("[data-kb-search]");
    if (!caja) return;
    var form = caja.querySelector("form"), input = caja.querySelector("input[type=search]"),
        sug = caja.querySelector("[data-kb-sug]"), timer = null, ultimo = "";

    function pinta() {
      var q = input.value;
      if (norm(q).trim().length < 2) { sug.hidden = true; return; }
      ultimo = q;
      getFeed().then(function (feed) {
        if (input.value !== ultimo) return;
        var res = buscar(feed.articles, q).slice(0, 5), tema = temaDe(q), html = "";
        if (tema) html += '<a href="' + tema.u + '"><span class="kb-t">Ver pasteles de ' + tema.n + '</span><span class="kb-c">Catálogo</span></a>';
        html += res.map(function (a) {
          return '<a href="' + a.url + '"><span class="kb-t">' + a.title + '</span><span class="kb-c">' + (a.category_name || "Ayuda") + "</span></a>";
        }).join("");
        sug.innerHTML = html || '<div class="kb-vacio">' + T.sinCoincidencias + "</div>";
        sug.hidden = false;
      });
    }
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(pinta, 110); });
    input.addEventListener("focus", pinta);
    document.addEventListener("click", function (e) { if (!e.target.closest("[data-kb-search]")) sug.hidden = true; });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      sug.hidden = true;
      getFeed().then(function (feed) {
        var res = buscar(feed.articles, q), tema = temaDe(q);
        reporta("/busqueda", { q: q, resultados: res.length, tema: tema ? tema.n : null, url: location.pathname });
        if (tema) { window.location.href = tema.u; return; }
        if (res.length) { window.location.href = res[0].url; return; }
        // SIN `type=article`: así Shopify busca también en los PRODUCTOS.
        // Con el filtro puesto, quien escribía "rainbow" en la caja del centro
        // de ayuda acababa en una página vacía, teniendo la tienda media
        // docena de pasteles de arcoíris.
        window.location.href = RAIZ + "/search?q=" + encodeURIComponent(q);
      });
    });

    root.querySelectorAll("[data-kb-pista]").forEach(function (b) {
      b.addEventListener("click", function () {
        input.value = b.getAttribute("data-kb-pista");
        input.focus();
        pinta();
      });
    });
  }

  /* ---------- índice lateral y tablas del artículo ---------- */
  function initArticulo(root) {
    var prosa = root.querySelector("[data-kb-prosa]");
    if (!prosa) return;

    prosa.querySelectorAll("table").forEach(function (t) {
      if (t.parentNode && t.parentNode.classList.contains("kb-tabla")) return;
      var w = document.createElement("div"); w.className = "kb-tabla";
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });

    var toc = root.querySelector("[data-kb-toc]");
    if (toc) {
      var hs = prosa.querySelectorAll("h2");
      if (hs.length < 2) { var wrap = toc.closest("[data-kb-tocwrap]"); if (wrap) wrap.hidden = true; }
      else {
        var html = "";
        hs.forEach(function (h, i) {
          if (!h.id) h.id = "kb-s" + (i + 1);
          html += '<a href="#' + h.id + '">' + h.textContent + "</a>";
        });
        toc.innerHTML = html;
      }
    }

    var fb = root.querySelector("[data-kb-voto]");
    if (fb) {
      var handle = fb.getAttribute("data-kb-voto");
      fb.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var util = b.getAttribute("data-v") === "si";
          reporta("/voto", { handle: handle, util: util, url: location.pathname });
          fb.hidden = true;
          var ok = root.querySelector("[data-kb-voto-ok]");
          if (ok) { ok.hidden = false; ok.textContent = util ? T.graciasSi : T.graciasNo; }
        });
      });
    }
  }

  /* ---------- el chat ---------- */
  function initChat() {
    var burbuja = document.getElementById("kb-burbuja"), panel = document.getElementById("kb-panel");
    if (!burbuja || !panel) return;
    var cp = panel.querySelector("[data-kb-chat-cuerpo]"),
        form = panel.querySelector("form"),
        input = panel.querySelector("input"),
        cerrar = panel.querySelector("[data-kb-cerrar]");
    var abierto = false, saludado = false;

    function nodo(html, clase) {
      var d = document.createElement("div");
      d.className = clase || "kb-msg kb-bot";
      d.innerHTML = html;
      // Todo lo que sale por la burbuja va al número de la burbuja.
      if (window.aFlotante) aFlotante(d);
      cp.appendChild(d); cp.scrollTop = cp.scrollHeight; return d;
    }
    function yo(t) { nodo("<span>" + t + "</span>", "kb-msg kb-yo"); }

    function chips(items) {
      return '<div class="kb-chips">' + items.map(function (x) {
        if (x.href) {
          var ext = x.href.indexOf("http") === 0;
          return '<a class="kb-wchip' + (x.alt ? " kb-alt" : "") + '" href="' + x.href + '"' + (ext ? ' target="_blank" rel="noopener"' : "") + ">" + x.t + "</a>";
        }
        return '<button type="button" data-kb-art="' + x.id + '">' + x.t + "</button>";
      }).join("") + "</div>";
    }

    function cierre(a) {
      var c = (window.ctaDe ? ctaDe({ id: a.handle, cat: a.category }) : null);
      if (!c) return "";
      return chips(c.a.map(function (x) { return { t: x[0], href: x[1], alt: x[2] !== "primario" }; }));
    }

    function responde(a) {
      nodo('<div class="kb-resp"><span class="kb-eyebrow">' + (a.category_name || "Ayuda") + '</span><p>' + a.answer + '</p>' +
        '<a class="kb-leer" href="' + a.url + '">' + T.leerCompleto + "</a></div>" + cierre(a));
    }

    function saluda() {
      if (saludado) return; saludado = true;
      nodo(T.saludo);
      getFeed().then(function (feed) {
        var top = feed.articles.slice(0, 4).map(function (a) { return { t: a.title, id: a.handle }; });
        if (top.length) nodo(chips(top));
      });
    }

    /* ---------- el agente ----------
       Se le pregunta PRIMERO. Si contesta, esa es la respuesta y debajo van las
       fuentes, para que se vea de dónde salió. Si está apagado, si falta la
       llave, si el modelo falla o si tarda demasiado, no pasa nada: se sigue
       por el camino de siempre (buscar en los artículos y, si no, WhatsApp).
       El widget nunca depende de que el agente esté vivo. */
    var charla = null;
    var historial = [];

    function preguntaAlAgente(q) {
      if (!charla) {
        charla = String(Date.now()).slice(-8) + Math.random().toString(36).slice(2, 10);
      }
      var corta = new AbortController();
      var reloj = setTimeout(function () { corta.abort(); }, 20000);
      return fetch(API + "/agente", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ q: q, historial: historial.slice(-6), conversacion: charla, url: location.pathname }),
        signal: corta.signal
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { clearTimeout(reloj); return j && j.ok ? j : null; })
        .catch(function () { clearTimeout(reloj); return null; });
    }

    function pintaRespuestaDelAgente(r, feed) {
      corrigeElIdiomaDelBoton(r.idioma);
      var cuerpo = document.createElement("div");
      cuerpo.className = "kb-msg kb-bot";
      var parrafos = String(r.respuesta || "").split(/\n\s*\n/).filter(Boolean);
      cuerpo.innerHTML = parrafos.map(function (t) {
        return "<p>" + t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\n/g, "<br>") + "</p>";
      }).join("");

      // De dónde lo sacó. Es lo que separa esto de un bot que se lo inventa.
      if (r.fuentes && r.fuentes.length && feed) {
        var vistos = {};
        var enlaces = r.fuentes.map(function (h) {
          if (vistos[h]) return "";
          vistos[h] = 1;
          var a = feed.articles.filter(function (x) { return String(x.handle).split("/").pop() === h; })[0];
          return a ? '<a href="' + a.url + '">' + a.title + "</a>" : "";
        }).filter(Boolean).join("");
        if (enlaces) {
          cuerpo.innerHTML += '<div class="kb-fuentes"><span class="kb-eyebrow">' +
            tablaDe(r.idioma).deDonde + "</span>" + enlaces + "</div>";
        }
      }
      if (window.aFlotante) aFlotante(cuerpo);
      cp.appendChild(cuerpo);

      /* A DÓNDE VA. El agente nombra la colección que le toca, pero su respuesta
         se pinta como TEXTO —se escapa a propósito, para que no pueda meter
         HTML—, así que nombrarla no basta: el cliente no tenía nada que pulsar
         y acababa en el catálogo entero, con miles de productos.
         El ERP ya comprobó que la colección existe antes de mandarla; aquí solo
         se pinta, con el prefijo de idioma de esta visita. */
      if (r.coleccion && r.coleccion.url) {
        /* TRES PIEZAS DE VERDAD, con su foto. Nombrar la colección ya era mejor
           que mandar al catálogo entero, pero el cliente sigue teniendo que
           buscar. Enseñándole lo que hay, decide viendo.
           Los títulos van escapados: vienen del catálogo, no de nosotros. */
        if (r.productos && r.productos.length) {
          var tarjetas = r.productos.map(function (p) {
            var img = p.imagen
              ? '<img src="' + esc(p.imagen) + '" alt="" loading="lazy">'
              : "";
            return '<a class="kb-prod" href="' + esc(RAIZ + p.url) + '">' + img +
              "<span>" + esc(p.titulo) + "</span></a>";
          }).join("");
          nodo('<div class="kb-prods">' + tarjetas + "</div>");
        }
        nodo(chips([{
          t: tablaDe(r.idioma).verLos + r.coleccion.titulo,
          href: RAIZ + r.coleccion.url
        }]));
      }

      cp.scrollTop = cp.scrollHeight;

      /* No supo: se pasa con una persona, sin disimular.
         El botón de "ver el catálogo" solo se pone si NO hay una colección
         concreta: teniendo al lado "Ver Pasteles para Mujer", mandar además al
         catálogo entero es ofrecer el sitio malo junto al bueno. */
      if (!r.contesto) {
        var salidas = [{
          t: tablaDe(r.idioma).hablar,
          href: window.waTexto
            ? waTexto((r.idioma === "en" ? "Hi, I have a question: " : "Hola, tengo una duda: ") + q0)
            : "https://wa.me/" + r.whatsapp
        }];
        if (!(r.coleccion && r.coleccion.url)) {
          salidas.push({ t: tablaDe(r.idioma).verCatalogo, href: RAIZ + "/collections/all", alt: true });
        }
        nodo(chips(salidas));
      }
    }

    var q0 = "";

    /* EL VENDEDOR ABRE WHATSAPP SABIENDO QUÉ QUERÍA EL CLIENTE.

       El botón grande del pie llevaba un texto genérico, "Hola, tengo una duda
       sobre un pastel", así que quien contesta empezaba de cero y el cliente
       tenía que repetir lo que acababa de escribir. Ahora el botón se reescribe
       con SU pregunta, la de verdad, la primera de la conversación.

       Se usa la PRIMERA y no la última a propósito: es la que dice a qué venía.
       Las siguientes suelen ser matices de esa. */
    var preguntaDelCliente = "";
    var idiomaDelBoton = "";

    function escribeElBoton(idioma) {
      var boton = panel.querySelector("[data-kb-wa]");
      if (!boton || !preguntaDelCliente) return;
      idiomaDelBoton = idioma;
      var enca = idioma === "en"
        ? "Hi, this is what I asked on your site: \u00ab"
        : "Hola, esto es lo que pregunté en su sitio: \u00ab";
      boton.setAttribute("data-kb-wa", enca + preguntaDelCliente + "\u00bb");
      if (window.waTexto) boton.href = waTexto(boton.getAttribute("data-kb-wa"));
      if (window.aFlotante) aFlotante(panel);
    }

    function ponContextoEnElBoton(q) {
      if (!q || preguntaDelCliente) return;
      preguntaDelCliente = String(q).replace(/\s+/g, " ").trim().slice(0, 220);
      escribeElBoton(idiomaDe(q));
    }

    /* El agente lee mejor el idioma que la cuenta de palabras de aquí: tiene la
       frase entera y no una lista de doce palabras. Cuando discrepan, manda él,
       y el encabezado del mensaje al vendedor se reescribe. La pregunta no se
       toca: esa es del cliente y va literal. */
    function corrigeElIdiomaDelBoton(idioma) {
      if (!idioma || !preguntaDelCliente) return;
      if (idioma === idiomaDelBoton) return;
      escribeElBoton(idioma);
    }

    /* CONTESTAR UN "QUIERO UN PASTEL DE X" SIN LLAMAR AL MODELO.
       Jaime: *"apoco no puedes... sin que estés gastando tokens? échale
       ciencia"*. Tenía razón: eso no es redactar, es buscar. Lo resuelve el
       buscador de Shopify en ~400 ms y sin gastar nada, y lo que hay que decir
       cabe en una frase, porque lo que informa son las piezas y el botón, no
       el párrafo. */
    function pintaCatalogo(r) {
      var T2 = tablaDe(idiomaDe(q0));
      nodo('<div class="kb-msg kb-bot"><p>' + T2.tenemosDe + "<strong>" +
        esc(r.coleccion.titulo) + "</strong>" + T2.tenemosDeFin + "</p></div>");

      if (r.productos && r.productos.length) {
        nodo('<div class="kb-prods">' + r.productos.map(function (p) {
          var img = p.imagen ? '<img src="' + esc(p.imagen) + '" alt="" loading="lazy">' : "";
          return '<a class="kb-prod" href="' + esc(RAIZ + p.url) + '">' + img +
            "<span>" + esc(p.titulo) + "</span></a>";
        }).join("") + "</div>");
      }

      nodo(chips([{ t: T2.verLos + r.coleccion.titulo, href: RAIZ + r.coleccion.url }]));

      // Y la salida honesta: puede que ninguno sea lo que tiene en la cabeza.
      nodo('<div class="kb-msg kb-bot"><p style="font-size:.86rem;color:var(--kb-tinta-3)">' +
        T2.noEsExacto + "</p></div>");
    }

    function preguntaAlCatalogo(q) {
      var corta = new AbortController();
      var reloj = setTimeout(function () { corta.abort(); }, 6000);
      return fetch(API + "/catalogo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ q: q }),
        signal: corta.signal
      })
        .then(function (x) { return x.ok ? x.json() : null; })
        .then(function (j) { clearTimeout(reloj); return j && j.ok ? j : null; })
        .catch(function () { clearTimeout(reloj); return null; });
    }

    /* NO SE MANDA LO QUE NO ES UNA PREGUNTA.
       El 2026-08-30 alguien dictó por voz desde una ficha de producto y su
       teclado envió palabra por palabra: veinte envíos en dos minutos con "La",
       "P", "l", "que", "lleve". El bot le contestó párrafos a letras sueltas y
       se pagó una llamada al modelo por cada una: el 56% de los turnos reales
       de esa semana y un tercio del gasto.
       Tres candados, y el de "ya hay una en marcha" es el que de verdad frena
       una ráfaga. El servidor corta también, por si el navegador guarda el
       kb.js viejo. */
    var ultimaPregunta = "";
    var ultimaEn = 0;
    var enMarcha = false;

    function valeLaPena(q) {
      var t = String(q || "").trim();
      if (t.length < 4) { return false; }
      if (enMarcha) { return false; }
      if (t === ultimaPregunta && Date.now() - ultimaEn < 10000) { return false; }
      return true;
    }

    function pregunta(q) {
      if (!valeLaPena(q)) { return; }
      ultimaPregunta = String(q).trim();
      ultimaEn = Date.now();
      enMarcha = true;
      q0 = q;
      ponContextoEnElBoton(q);
      yo(q);

      /* SALUDAR DE VUELTA.
         De las búsquedas que no encontraron nada, catorce eran "Hola" y sus
         variantes. A todas les contestábamos "No tengo publicado nada sobre
         «Hola»", que es la peor frase posible para abrir una conversación con
         alguien que viene a comprar un pastel.
         No se registra como búsqueda: un saludo no es una pregunta sin
         respuesta, y colarlo en esa lista ensucia justo el dato que sirve para
         saber qué artículo falta por escribir. */
      if (esSaludo(q)) {
        enMarcha = false;
        nodo(tablaDe(idiomaDe(q)).saludo);
        getFeed().then(function (feed) {
          var top = feed.articles.slice(0, 4).map(function (a) { return { t: a.title, id: a.handle }; });
          if (top.length) nodo(chips(top));
        });
        return;
      }

      getFeed().then(function (feed) {
        var tema = temaDe(q), res = buscar(feed.articles, q);
        reporta("/busqueda", { q: q, resultados: res.length, tema: tema ? tema.n : null, origen: "chat", url: location.pathname });

        /* PRIMERO EL CATÁLOGO, QUE NO CUESTA NADA.
           Si la pregunta es "quiero un pastel de X" y X existe como colección,
           se contesta con ella y sus piezas: ~400 ms y cero tokens, frente a
           ~5 s y una llamada al modelo. El ERP se aparta solo cuando la
           pregunta trae algo más que un tema —sin gluten, para 40 personas,
           cuánto cuesta, para mañana—; ahí sí hace falta que alguien conteste.
           PRIMERO EL AGENTE cuando el catálogo no resuelve, también si
           reconocemos el tema.
           Aquí había un atajo: si `temaDe()` cazaba la palabra —barbie, boda,
           unicornio— se resolvía con la colección y NO se llamaba al agente.
           Tenía sentido cuando el agente no conocía el catálogo. Ya no: ahora
           conoce las 69 colecciones publicadas, elige la que toca y devuelve
           TRES piezas de verdad con su foto. La lista de aquí son 46 palabras
           escritas a mano y no trae ni un producto.
           `tema` sigue viajando abajo: es la red para cuando el agente está
           apagado, falla o tarda demasiado. */
        escribiendo(true);
        return preguntaAlCatalogo(q).then(function (cat) {
          if (cat) { escribiendo(false); pintaCatalogo(cat); return null; }
          return preguntaAlAgente(q);
        }).then(function (r) {
          enMarcha = false;
          if (r === null) { return; }
          escribiendo(false);
          if (r && r.respuesta) {
            historial.push({ rol: "user", texto: q });
            historial.push({ rol: "assistant", texto: r.respuesta });
            pintaRespuestaDelAgente(r, feed);
            return;
          }
          sigueSinAgente(feed, tema, res, q);
        });
      })
        // EL CANDADO SE SUELTA PASE LO QUE PASE. Si el índice o la red fallan
        // y se queda echado, el widget se vuelve mudo para siempre y el
        // cliente escribe sin que pase nada: peor que el problema que resuelve.
        .catch(function () { enMarcha = false; escribiendo(false); })
        .then(function () { enMarcha = false; });
    }

    // Tres puntitos mientras el agente piensa. Sin esto, veinte segundos de
    // silencio parecen que se rompió.
    function escribiendo(encendido) {
      var viejo = cp.querySelector("[data-kb-pensando]");
      if (viejo) viejo.remove();
      if (!encendido) return;
      var d = document.createElement("div");
      d.className = "kb-msg kb-bot kb-pensando";
      d.setAttribute("data-kb-pensando", "1");
      d.innerHTML = "<span></span><span></span><span></span>";
      cp.appendChild(d);
      cp.scrollTop = cp.scrollHeight;
    }

    /* SIN AGENTE SE HABLA EL IDIOMA DE LA PÁGINA, no el del cliente.
       Aquí no se redacta nada: se sirven los artículos del blog de ESTA página,
       que están escritos en su idioma. Traducir solo los botones dejaría un
       artículo en español rodeado de botones en inglés, que se lee peor que
       todo en un idioma. Quien pregunta en inglés y cae aquí tiene el enlace
       de idioma arriba. */
    function sigueSinAgente(feed, tema, res, q) {
      (function () {
        if (tema) {
          nodo(T.siTenemos + "<strong>" + tema.n + "</strong>" + T.cakesOf);
          nodo(chips([{ t: T.verColeccion + tema.n + T.verColeccionFin, href: tema.u },
                      { t: T.aMedida, href: window.waTexto ? waTexto((ES_INGLES ? "Hi, I would like a " : "Hola, quiero un pastel de ") + tema.n + ".") : "https://wa.me/525519290505", alt: true }]));
          if (res.length) responde(res[0]);
          return;
        }
        if (!res.length) {
          // Antes de decir que no hay nada, mirar si el catálogo lo tiene.
          buscaEnLaTienda(q).then(function (hallazgo) {
            if (hallazgo) {
              var cuantos = hallazgo.productos.length;
              nodo(T.enCatalogo + "<strong>" + hallazgo.termino + "</strong>" + T.enCatalogoFin);
              nodo(chips(hallazgo.productos.slice(0, 3).map(function (p) {
                return { t: p.title, href: p.url };
              }).concat([{
                t: T.verTodos + hallazgo.termino,
                href: RAIZ + "/search?q=" + encodeURIComponent(hallazgo.termino) + "&type=product",
                alt: true
              }])));
              return;
            }
            nodo(T.noTengo1 + "<em>" + q + "</em>" + T.noTengo2);
            nodo(chips([{ t: T.preguntarWa, href: window.waTexto ? waTexto((ES_INGLES ? "Hi, I want to ask about: " : "Hola, quiero preguntar por: ") + q) : "https://wa.me/525519290505" },
                        { t: T.comoPedimos, id: ES_INGLES ? "can-you-personalise-a-cake-to-my-idea" : "personalizar", alt: true }]));
          });
          return;
        }
        responde(res[0]);
        if (res.length > 1) {
          nodo('<span style="font-size:.86rem;color:var(--kb-tinta-3)">' + T.tambien + "</span>" +
            chips(res.slice(1, 3).map(function (a) { return { t: a.title, id: a.handle }; })));
        }
      })();
    }

    function abre() { abierto = true; panel.hidden = false; burbuja.hidden = true; saluda(); setTimeout(function () { input.focus(); }, 90); }
    function cierra() { abierto = false; panel.hidden = true; burbuja.hidden = false; }

    burbuja.addEventListener("click", abre);
    if (cerrar) cerrar.addEventListener("click", cierra);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && abierto) cierra(); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = input.value.trim(); if (!q) return;
      input.value = ""; pregunta(q);
    });
    cp.addEventListener("click", function (e) {
      var b = e.target.closest("[data-kb-art]");
      if (!b) return;
      var h = b.getAttribute("data-kb-art");
      getFeed().then(function (feed) {
        var a = feed.articles.filter(function (x) { return x.handle === h; })[0];
        if (!a) return;
        yo(a.title); responde(a);
      });
    });
  }

  /* ---------- enlaces de WhatsApp: web en escritorio, app en el teléfono ---------- */
  function initWhats() {
    if (!window.waTexto) return;
    document.querySelectorAll("[data-kb-wa]").forEach(function (a) {
      a.href = waTexto(a.getAttribute("data-kb-wa") || "Hola, tengo una duda sobre un pastel.");
    });
  }

  /* ---------- cierre comercial del artículo ---------- */
  function initCta() {
    var caja = document.querySelector("[data-kb-cta]");
    if (!caja || !window.ctaDe) return;
    var c = ctaDe({ id: caja.getAttribute("data-kb-cta"), cat: caja.getAttribute("data-kb-cat") });
    if (!c) return;
    caja.innerHTML = "<h3>" + c.t + "</h3><p>" + c.d + "</p><div class='kb-acciones'>" +
      c.a.map(function (x) {
        var ext = x[1].indexOf("http") === 0;
        return '<a class="' + (x[2] === "primario" ? "kb-b-1" : "kb-b-2") + '" href="' + x[1] + '"' + (ext ? ' target="_blank" rel="noopener"' : "") + ">" + x[0] + "</a>";
      }).join("") + "</div>";
    caja.hidden = false;
  }

  /* ---------- convivir con otros botones flotantes ----------
     El sitio puede traer ya un botón en esa esquina (el de "subir", el de otra
     app). Si lo hay, el nuestro se sube 72 px en vez de encimarse.

     Dos cosas que costaron descubrirse:

     1. No basta con que el vecino exista y sea `fixed`. La flecha de "volver
        arriba" del tema vive FUERA de la pantalla hasta que bajas, y contarla
        siempre dejaba nuestra burbuja subida 72 px sin motivo. En el teléfono
        se notaba de sobra: flotando a media altura, lejos del pulgar.

     2. Y como ese vecino aparece al bajar, hay que volver a mirar mientras la
        persona rueda la página, no solo al cargar. */
  function fueraDePantalla(r) {
    return r.bottom <= 0 || r.right <= 0 ||
           r.top >= window.innerHeight || r.left >= window.innerWidth;
  }

  function evitarChoque() {
    var burbuja = document.getElementById("kb-burbuja");
    var panel = document.getElementById("kb-panel");
    if (!burbuja) return;

    var otros = document.querySelectorAll(
      '[id^="zoko-"], [class*="whatsapp" i], [id*="whatsapp" i], .main-go-top, #go-top, [class*="chat-widget" i]'
    );
    var choca = false;
    var mio = burbuja.getBoundingClientRect();
    for (var i = 0; i < otros.length; i++) {
      var e = otros[i];
      if (e === burbuja || burbuja.contains(e) || (panel && panel.contains(e))) continue;
      var cs = window.getComputedStyle(e);
      if (cs.position !== "fixed" || cs.display === "none" || cs.visibility === "hidden") continue;
      if (parseFloat(cs.opacity) < 0.1) continue;
      var r = e.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) continue;
      if (fueraDePantalla(r)) continue;
      // ¿Está en la misma esquina y a la misma altura?
      var solapa = !(r.right < mio.left || r.left > mio.right || r.bottom < mio.top || r.top > mio.bottom);
      var mismaEsquina = (window.innerWidth - r.right) < 140 && (window.innerHeight - r.bottom) < 140;
      if (solapa || mismaEsquina) { choca = true; break; }
    }
    burbuja.classList.toggle("kb-subida", choca);
    if (panel) panel.classList.toggle("kb-subida", choca);
  }

  function arranca() {
    var root = document.querySelector(".kb-root");
    if (root) { initBuscador(root); initArticulo(root); initCta(); }
    initChat(); initWhats();

    /* EL WHATSAPP SE REPARTE. Se pregunta al ERP a quién le toca esta visita y
       se reescriben TODOS los enlaces de la página, no solo los del flotante:
       el cierre de un artículo y el botón de la burbuja tienen que mandar a la
       misma persona, o el cliente acabaría escribiéndole a dos vendedores.

       Va después de initWhats a propósito, que es quien acaba de escribirlos
       con el número base. */
    if (window.pideVendedor) {
      pideVendedor().then(function () { if (window.aFlotante) aFlotante(document); });
    } else if (window.aFlotante) {
      aFlotante(document);
    }
    evitarChoque();
    setTimeout(evitarChoque, 3000);   // esos widgets suelen pintarse tarde
    window.addEventListener("resize", pedirRepaso);
    window.addEventListener("scroll", pedirRepaso, { passive: true });
  }

  /* El scroll dispara muchísimas veces por segundo, así que se agrupa.

     Con `requestAnimationFrame` no: el navegador lo congela cuando la pestaña
     no está a la vista, y entonces la burbuja se queda donde estaba y aparece
     descolocada al volver. `setTimeout` sigue corriendo pase lo que pase.
     120 ms no se notan al dedo y bastan para no repasar en cada píxel. */
  var repasoPedido = false;
  function pedirRepaso() {
    if (repasoPedido) return;
    repasoPedido = true;
    setTimeout(function () { repasoPedido = false; evitarChoque(); }, 120);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arranca);
  else arranca();
})();
